import { render, staticRenderFns } from "./NewAccounts.vue?vue&type=template&id=51c55253&"
import script from "./NewAccounts.vue?vue&type=script&lang=js&"
export * from "./NewAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports